"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentStepTitle = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _contexts = require("../../contexts");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const SafetyMessage = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'grid',
        gridTemplateColumns: '20px 1fr',
        alignContent: 'center',
        justifyContent: 'start',
        gap: theme.spacing(1),
        margin: theme.spacing(1, 0, 4, 0)
    };
});
const PaymentStepTitle = ()=>{
    const { isSimplifiedCheckout } = (0, _contexts.useCheckoutPayment)();
    if (!isSimplifiedCheckout) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "h6",
                component: "h2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: "payment"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SafetyMessage, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Lock, {
                        fontSize: "small"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                            id: "safeAndTrustedPaymentMethods"
                        })
                    })
                ]
            })
        ]
    });
};
exports.PaymentStepTitle = PaymentStepTitle;
